// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StyledCalendarWrapper {
    /* width: 1200px; */
    min-height: 800px;
    display: flex;
    justify-content: center;
    position: relative;
}

.react-calendar {
    width: 100%;
    min-width: 800px;
    border: none;
    border-radius: 0.5rem;
    /* box-shadow: 4px 2px 10px 0px rgba(0, 0, 0, 0.13); */
    box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.161);
    padding: 15px;
    background-color: white;
}

.StyledCalendarWrapper.dark .react-calendar {
    background-color: #242424;
    box-shadow: 1px 1px 5px 2px #ffffff4d;
    color: #dddbdb;
}

/* 전체 폰트 컬러 */
.react-calendar__month-view {
    color: gray;
}

/* 네비게이션 가운데 정렬 */
.react-calendar__navigation {
    justify-content: center;
    margin-bottom: 0;
}

/* 네비게이션 폰트 설정 */
.react-calendar__navigation button {
    font-weight: 800;
    font-size: 1rem;
}

/* 네비게이션 버튼 컬러 */
.react-calendar__navigation button:focus {
    background-color: white;
}

/* 네비게이션 비활성화 됐을때 스타일 */
.react-calendar__navigation button:disabled {
    background-color: white;
    color: darkblue;
}

/* 년/월 상단 네비게이션 칸 크기 줄이기 */
.react-calendar__navigation__label {
    flex-grow: 0 !important;
}

/* 요일 밑줄 제거 */
.react-calendar__month-view__weekdays abbr {
    text-decoration: none;
    font-weight: 800;
}

/* 일요일에만 빨간 폰트 */
.react-calendar__month-view__weekdays__weekday--weekend abbr[title="일요일"] {
    color: red;
}

/* 오늘 날짜 폰트 컬러 */
.react-calendar__tile--now {
    background: none;
    /* color: white; */
}

/* 네비게이션 월 스타일 적용 */
.react-calendar__year-view__months__month {
    border-radius: 0.8rem;
    /* background-color: gray; */
    padding: 0;
}

/* 네비게이션 현재 월 스타일 적용 */
.react-calendar__tile--hasActive {
    background-color: #003577;
    color: white;
}

/* 일 날짜 간격 */
.react-calendar__tile {
    padding: 10px 0px;
    position: relative;
    height: 140px;
    border: 1px solid #fff !important;
    background-color: #f7f7f7 !important;
    display: flex;
    justify-content: center;
}

.StyledCalendarWrapper.dark .react-calendar__tile {
    background-color: #494848 !important;
    border: 1px solid #5f5e5e !important;
    color: #121214;
}

/* 네비게이션 월 스타일 적용 */
.react-calendar__year-view__months__month {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.3333% - 10px);
    /* margin-inline-start: 5px !important; */
    /* margin-inline-end: 5px !important; */
    margin-block-end: 10px;
    padding: 20px 6.6667px;
    font-size: 0.9rem;
    font-weight: 600;
    color: black;
}

.react-calendar__month-view__days {
    border: 1px solid rgb(243, 243, 243) !important;
}

.StyledCalendarWrapper.dark .react-calendar__month-view__days {
    border: 1px solid #5f5e5e !important;
}

/* 선택한 날짜 스타일 적용 */
/* .react-calendar__tile:enabled:focus,
.react-calendar__tile--active,
.react-calendar__tile--active:hover {
    background-color: #ffe2a8 !important;
    border: 1px solid #ffe2a8 !important;
    border-radius: 0.3rem;
    color: black;
} */

.react-calendar__tile:enabled:hover {
    background-color: rgb(216, 216, 216) !important;
}

.StyledCalendarWrapper.dark .react-calendar__tile:enabled:hover {
    background-color: #636363 !important;
}

.react-calendar__tile:enabled:focus,
.react-calendar__tile--active,
.react-calendar__tile--active:hover {
    color: black;
}

.react-calendar__tile--active abbr {
    background-color: #003577 !important;
    color: #fff;
}

.react-calendar__month-view__days__day abbr {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.StyledDate {
    position: absolute;
    right: 3%;
    top: 25px;
    background-color: #003577;
    color: white;
    width: 100px;
    min-width: fit-content;
    height: 2rem;
    text-align: center;
    margin: 0 auto;
    line-height: 1.6rem;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.StyledType {
    position: absolute;
    left: 4%;
    top: 32px;
    width: 100px;
    min-width: fit-content;
    height: 1.5rem;
    text-align: center;
    margin: 0 auto;
    line-height: 1.6rem;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.StyledType.dark {
    color: #121214;
}

.StyledType-1 {
    width: 50px;
    height: 17px;
    background-color: #fffbc3;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding-left: 3px;
}

.StyledType-2 {
    width: 50px;
    height: 20px;
    background-color: #c5e2f7;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding-left: 3px;
}

.StyledType-3 {
    width: 50px;
    height: 20px;
    background-color: #f7c5c5;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding-left: 3px;
}

.StyledToday {
    font-size: x-small;
    color: navy;
    font-weight: 600;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
}

.StyledDot {
    background-color: navy;
    border-radius: 50%;
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
}

.StyledEX {
    font-size: 10px;
    color: black;
    font-weight: 600;
    position: absolute;
    top: 50px;
    width: 100%;
}

.StyledEX-1,
.StyledEX-2,
.StyledEX-3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px 5px;
}

.StyledEX-1 {
    width: 100%;
    background-color: #D1DCF4;
    border-radius: 5px;
    margin-bottom: 5px;
}

.StyledEX-2 {
    width: 100%;
    background-color: #FFBFBF;
    border-radius: 5px;
    margin-bottom: 5px;
}

.StyledEX-3 {
    width: 100%;
    background-color: #a0df9a;
    border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/calendar.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,sDAAsD;IACtD,gDAAgD;IAChD,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,qCAAqC;IACrC,cAAc;AAClB;;AAEA,aAAa;AACb;IACI,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,uBAAuB;AAC3B;;AAEA,uBAAuB;AACvB;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA,0BAA0B;AAC1B;IACI,uBAAuB;AAC3B;;AAEA,aAAa;AACb;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,UAAU;AACd;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,UAAU;AACd;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,oCAAoC;IACpC,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;IACpC,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,YAA0C;IAA1C,cAA0C;IAA1C,iCAA0C;IAC1C,yCAAyC;IACzC,uCAAuC;IACvC,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;AACxC;;AAEA,kBAAkB;AAClB;;;;;;;GAOG;;AAEH;IACI,+CAA+C;AACnD;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":[".StyledCalendarWrapper {\r\n    /* width: 1200px; */\r\n    min-height: 800px;\r\n    display: flex;\r\n    justify-content: center;\r\n    position: relative;\r\n}\r\n\r\n.react-calendar {\r\n    width: 100%;\r\n    min-width: 800px;\r\n    border: none;\r\n    border-radius: 0.5rem;\r\n    /* box-shadow: 4px 2px 10px 0px rgba(0, 0, 0, 0.13); */\r\n    box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.161);\r\n    padding: 15px;\r\n    background-color: white;\r\n}\r\n\r\n.StyledCalendarWrapper.dark .react-calendar {\r\n    background-color: #242424;\r\n    box-shadow: 1px 1px 5px 2px #ffffff4d;\r\n    color: #dddbdb;\r\n}\r\n\r\n/* 전체 폰트 컬러 */\r\n.react-calendar__month-view {\r\n    color: gray;\r\n}\r\n\r\n/* 네비게이션 가운데 정렬 */\r\n.react-calendar__navigation {\r\n    justify-content: center;\r\n    margin-bottom: 0;\r\n}\r\n\r\n/* 네비게이션 폰트 설정 */\r\n.react-calendar__navigation button {\r\n    font-weight: 800;\r\n    font-size: 1rem;\r\n}\r\n\r\n/* 네비게이션 버튼 컬러 */\r\n.react-calendar__navigation button:focus {\r\n    background-color: white;\r\n}\r\n\r\n/* 네비게이션 비활성화 됐을때 스타일 */\r\n.react-calendar__navigation button:disabled {\r\n    background-color: white;\r\n    color: darkblue;\r\n}\r\n\r\n/* 년/월 상단 네비게이션 칸 크기 줄이기 */\r\n.react-calendar__navigation__label {\r\n    flex-grow: 0 !important;\r\n}\r\n\r\n/* 요일 밑줄 제거 */\r\n.react-calendar__month-view__weekdays abbr {\r\n    text-decoration: none;\r\n    font-weight: 800;\r\n}\r\n\r\n/* 일요일에만 빨간 폰트 */\r\n.react-calendar__month-view__weekdays__weekday--weekend abbr[title=\"일요일\"] {\r\n    color: red;\r\n}\r\n\r\n/* 오늘 날짜 폰트 컬러 */\r\n.react-calendar__tile--now {\r\n    background: none;\r\n    /* color: white; */\r\n}\r\n\r\n/* 네비게이션 월 스타일 적용 */\r\n.react-calendar__year-view__months__month {\r\n    border-radius: 0.8rem;\r\n    /* background-color: gray; */\r\n    padding: 0;\r\n}\r\n\r\n/* 네비게이션 현재 월 스타일 적용 */\r\n.react-calendar__tile--hasActive {\r\n    background-color: #003577;\r\n    color: white;\r\n}\r\n\r\n/* 일 날짜 간격 */\r\n.react-calendar__tile {\r\n    padding: 10px 0px;\r\n    position: relative;\r\n    height: 140px;\r\n    border: 1px solid #fff !important;\r\n    background-color: #f7f7f7 !important;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.StyledCalendarWrapper.dark .react-calendar__tile {\r\n    background-color: #494848 !important;\r\n    border: 1px solid #5f5e5e !important;\r\n    color: #121214;\r\n}\r\n\r\n/* 네비게이션 월 스타일 적용 */\r\n.react-calendar__year-view__months__month {\r\n    flex: 0 0 calc(33.3333% - 10px) !important;\r\n    /* margin-inline-start: 5px !important; */\r\n    /* margin-inline-end: 5px !important; */\r\n    margin-block-end: 10px;\r\n    padding: 20px 6.6667px;\r\n    font-size: 0.9rem;\r\n    font-weight: 600;\r\n    color: black;\r\n}\r\n\r\n.react-calendar__month-view__days {\r\n    border: 1px solid rgb(243, 243, 243) !important;\r\n}\r\n\r\n.StyledCalendarWrapper.dark .react-calendar__month-view__days {\r\n    border: 1px solid #5f5e5e !important;\r\n}\r\n\r\n/* 선택한 날짜 스타일 적용 */\r\n/* .react-calendar__tile:enabled:focus,\r\n.react-calendar__tile--active,\r\n.react-calendar__tile--active:hover {\r\n    background-color: #ffe2a8 !important;\r\n    border: 1px solid #ffe2a8 !important;\r\n    border-radius: 0.3rem;\r\n    color: black;\r\n} */\r\n\r\n.react-calendar__tile:enabled:hover {\r\n    background-color: rgb(216, 216, 216) !important;\r\n}\r\n\r\n.StyledCalendarWrapper.dark .react-calendar__tile:enabled:hover {\r\n    background-color: #636363 !important;\r\n}\r\n\r\n.react-calendar__tile:enabled:focus,\r\n.react-calendar__tile--active,\r\n.react-calendar__tile--active:hover {\r\n    color: black;\r\n}\r\n\r\n.react-calendar__tile--active abbr {\r\n    background-color: #003577 !important;\r\n    color: #fff;\r\n}\r\n\r\n.react-calendar__month-view__days__day abbr {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.StyledDate {\r\n    position: absolute;\r\n    right: 3%;\r\n    top: 25px;\r\n    background-color: #003577;\r\n    color: white;\r\n    width: 100px;\r\n    min-width: fit-content;\r\n    height: 2rem;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n    line-height: 1.6rem;\r\n    border-radius: 15px;\r\n    font-size: 0.8rem;\r\n    font-weight: 800;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.StyledType {\r\n    position: absolute;\r\n    left: 4%;\r\n    top: 32px;\r\n    width: 100px;\r\n    min-width: fit-content;\r\n    height: 1.5rem;\r\n    text-align: center;\r\n    margin: 0 auto;\r\n    line-height: 1.6rem;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n}\r\n\r\n.StyledType.dark {\r\n    color: #121214;\r\n}\r\n\r\n.StyledType-1 {\r\n    width: 50px;\r\n    height: 17px;\r\n    background-color: #fffbc3;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 3px;\r\n}\r\n\r\n.StyledType-2 {\r\n    width: 50px;\r\n    height: 20px;\r\n    background-color: #c5e2f7;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 3px;\r\n}\r\n\r\n.StyledType-3 {\r\n    width: 50px;\r\n    height: 20px;\r\n    background-color: #f7c5c5;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 3px;\r\n}\r\n\r\n.StyledToday {\r\n    font-size: x-small;\r\n    color: navy;\r\n    font-weight: 600;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.StyledDot {\r\n    background-color: navy;\r\n    border-radius: 50%;\r\n    width: 0.3rem;\r\n    height: 0.3rem;\r\n    position: absolute;\r\n    top: 60%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.StyledEX {\r\n    font-size: 10px;\r\n    color: black;\r\n    font-weight: 600;\r\n    position: absolute;\r\n    top: 50px;\r\n    width: 100%;\r\n}\r\n\r\n.StyledEX-1,\r\n.StyledEX-2,\r\n.StyledEX-3 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 3px 5px;\r\n}\r\n\r\n.StyledEX-1 {\r\n    width: 100%;\r\n    background-color: #D1DCF4;\r\n    border-radius: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.StyledEX-2 {\r\n    width: 100%;\r\n    background-color: #FFBFBF;\r\n    border-radius: 5px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.StyledEX-3 {\r\n    width: 100%;\r\n    background-color: #a0df9a;\r\n    border-radius: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
